export function firstImg(val) {
  if (val && val.length) {
    return val[0].url
  } else {
    return ''
  }
}
export function firstImgThumb(val) {
  if (val && val.length) {
    if (val[0].urlThumbnail) {
      return val[0].urlThumbnail
    } else {
      return val[0].url
    }
  } else {
    return ''
  }
}

// 农资
export function agrUnitFilter(i) {
  return `${i.num}${i.unit}/${i.pack}`
}

export function agrCountFilter(i) {
  return `${(i.count / i.num).toFixed(1)}${i.pack}`
}

export function agrTotalFilter(i) {
  return `${i.count}${i.unit}`
}

export function agrNameFilter(val) {
  return val.variety_name || val.registration_name || val.goods_name || val.product_name || '--'
}

export function agrFactoryFilter(val) {
  return val.apply_name || val.manufacturers || val.company_name || val.product_company || '--'
}

export function agrCodeFilter(val) {
  return val.registration_number || val.license_number || val.approval_number || '--'
}
